const Contact = () => {
  return (
    <form 
      className="message" 
      name="contact" 
      method="POST" 
      data-netlify="true"
    >
      <h5>Send Us a Message</h5>
      
      {/* 
        This hidden input is essential for Netlify to 
        identify which form is being submitted 
      */}
      <input type="hidden" name="form-name" value="contact" />

      <input 
        type="text" 
        name="name" 
        placeholder="NAME" 
        required 
      />
      <br /><br />

      <input 
        type="email" 
        name="email" 
        placeholder="EMAIL" 
        required 
      />
      <br /><br />

      <textarea 
        name="message" 
        rows="6" 
        placeholder="MESSAGE" 
        required 
      ></textarea>
      <br /><br />

      <button type="submit" className="btn pointer hover">
        Send Message
      </button>
    </form>
  );
};

export default Contact;